import { createElement, FC, MouseEvent, SyntheticEvent } from 'react';

import { DynamicSchemaDefinitionFiles } from '../../../../../generated/graphql';
import { FilesValue } from '../../../../types/DynamicSchema';
import { FileReference, UploadingFile, UploadingFilesProgress } from '../../../../types/Files';
import FileList, { FileListUploadingItem } from '../../FileList';
import FileUploader from '../../FileUploader';
import Base from './Base';
import FileListItem from './FileListItem';

type Props = {
  field: DynamicSchemaDefinitionFiles;
  bucketId: FilesValue;
  files: ReadonlyArray<FileReference>;
  uploadingFiles: ReadonlyArray<UploadingFile>;
  uploadingFilesProgress: UploadingFilesProgress;
  onRequestDeleteFile: (e: MouseEvent<HTMLElement>, file: FileReference, bucketId: string) => void;
  onRequestUploadFiles: (e: SyntheticEvent<HTMLElement>, files: ReadonlyArray<UploadingFile>, bucketId: string) => void;
  className?: string;
};

const FilesField: FC<Props> = ({
  field,
  bucketId,
  files,
  uploadingFiles,
  uploadingFilesProgress,
  onRequestDeleteFile,
  onRequestUploadFiles,
  className,
}) => {
  return (
    <Base field={field} labelPaddingTop={14} className={className}>
      <div>
        {files && files.length ? (
          <FileList>
            {[
              ...files.map((file) => (
                <FileListItem
                  file={file}
                  onClickDeleteButton={(e) => onRequestDeleteFile(e, file, bucketId!)}
                  key={file.id}
                />
              )),
              ...uploadingFiles.map((file) => {
                const targetProgressFile = uploadingFilesProgress[file.id];

                return (
                  <FileListUploadingItem
                    file={file}
                    key={`uploading-${file.id}`}
                    progress={targetProgressFile ? targetProgressFile.progress : 0}
                    state="uploading"
                  />
                );
              }),
            ]}
          </FileList>
        ) : null}

        <FileUploader onSelectFiles={(e, files) => onRequestUploadFiles(e, files, bucketId!)} />
      </div>
    </Base>
  );
};

export default FilesField;
